import { IScope, IWindowService } from "angular";
import { format, parseJSON } from "date-fns";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { MatchBet } from "../../interfaces/match-bet.interface";
import { Match } from "../../interfaces/match.interface";
import { BetService } from "../../services/bet.service";
import { GeneralService } from "../../services/general.service";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";

export class PreMatchPredictionsController {

	_$scope: IScope;
	_$window: IWindowService;
	// _Rollbar: any;
	awayBeforeHome = false;
	betService: BetService;
	btsDataUnavailable = false;
	configurationObject: BlockConfigurationObject;
	displayMaximumWidths = {
		"xxx-compact": 200,
		"xx-compact": 240,
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 699,
		"large": 800,
	};
	displayMode = "full";
	firstSetDataUnavailable = false;
	gamesError = false;
	gamesLoading = true;
	generalService: GeneralService;
	h2hBettingDataUnavailable = false;
	lineDataUnavailable = false;
	match: Match = null;
	matchService: MatchService;
	sportDataService: SportDataService;
	totalDataUnavailable = false;
	blockDomain: string;
	noGamesAvailable = false;


	

	/* @ngInject */
	constructor($scope: IScope, /*Rollbar: any,*/ $window: IWindowService, configurationObject: BlockConfigurationObject, matchService: MatchService,
		sportDataService: SportDataService, generalService: GeneralService, betService: BetService, blockDomain: string, public cdnDomain: string) {
		this._$scope = $scope;
		// this._Rollbar = Rollbar;
		this._$window = $window;
		this.configurationObject = configurationObject;
		this.matchService = matchService;
		this.sportDataService = sportDataService;
		this.generalService = generalService;
		this.betService = betService;
		this.blockDomain = blockDomain;

		
		generalService.initialiseBlock();

		if (!configurationObject.matchFirstTeam || configurationObject.matchFirstTeam === "away") {
			this.awayBeforeHome = true;
		}

		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID)
				&& $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});

	
		$window.addEventListener("resize", this.checkCompact);

		matchService.getGeoData().then(() => {
			this.retrieveSingleGame(configurationObject.matchID);
		}, () => {
			this.retrieveSingleGame(configurationObject.matchID);
		});
	}

	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID)
				&& this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});

		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
	}

	prepareMatchData = (): void => {
		this.match.MatchData.UserDate = parseJSON(this.match.MatchData.Date);
		try {
			if (this.configurationObject.dateDayBeforeMonth) {
				this.match.formattedLastUpdated = format(parseJSON(this.match.PreData.LastUpdated), "h:mma, d MMM");
			} else {
				this.match.formattedLastUpdated = format(parseJSON(this.match.PreData.LastUpdated), "h:mma, MMM d");
			}
		} catch {
			this.match.formattedLastUpdated = "Not Available";
		}
		
		if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "h2h")) {
			this.h2hBettingDataUnavailable = true;
		}

		if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "line")) {
			this.lineDataUnavailable = true;
		}

		if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "bts")) {
			this.btsDataUnavailable = true;
		}

		if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "total")) {
			this.totalDataUnavailable = true;
		}

		if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "firstset")) {
			this.firstSetDataUnavailable = true;
		}

		this.gamesLoading = false;

		//$scope.$apply();
	}

	retrieveSingleGame = (matchid: string): void => {
		this.gamesLoading = true;
		this.gamesError = false;

		if (/^[\w|]+_AUTO$/.test(matchid)) {
			const sportCode = matchid.match(/^([\w|]+)_AUTO$/)[1];
			let bookmakerList: Array<string> = [];
			if (this.configurationObject.bookmakers) {
				bookmakerList = this.configurationObject.bookmakers;
			} else if (this.configurationObject.bookmakerThemeSportExceptions
				&& this.configurationObject.bookmakerThemeSportExceptions.includes(sportCode)) {
				bookmakerList = ["tab"];
			} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}
			// if sport code is actually multiple codes separated by pipes, produce an array out of them, otherwise send the whole code as
			// a single-element array
			const sportArray = sportCode.includes("|") ? sportCode.split("|") : [sportCode];
			this.sportDataService.getUpcomingGames(sportArray, false, true, bookmakerList, this.configurationObject.sportExclusiveBookmakers)
				.then((matches) => {
					matches.forEach(m => {
						m.MatchData.UserDate = parseJSON(m.MatchData.Date);
					});
					
					const eligibleMatches = matches
						.filter(g => sportArray.some(s => s.toUpperCase() === g.MatchData.Sport.toUpperCase()) && this.matchService.matchIsUpcoming(g));

					if (eligibleMatches.length > 0) {
						this.match = eligibleMatches.sort((a,b) => this.matchService.gameDisplaySort(a,b))[0];
						this.configurationObject.matchID = this.match.MatchData.SIMatchID;

						this.prepareMatchData();
				
					} else {
						// this._Rollbar.error("Attempted to use AUTO match centre embed with no upcoming games available");
						console.error("Attempted to use AUTO match centre embed with no upcoming games available");
						this.noGamesAvailable = true;
					}
					this.gamesLoading = false;
				})
				.catch((err) => {
					if (err !== "API_CALL_FAILED") {
						// this._Rollbar.error(err);
						console.error(err);
					}
					this.gamesError = true;
				});
		} else {
			const sportCode = matchid.split("_")[0];
			let bookmakerList: Array<string> = [];
			if (this.configurationObject.sportExclusiveBookmakers
				&& Object.keys(this.configurationObject.sportExclusiveBookmakers).includes(sportCode.toUpperCase())) {
				bookmakerList = [this.configurationObject.sportExclusiveBookmakers[sportCode.toUpperCase()]];
			} else if (this.configurationObject.bookmakers) {
				bookmakerList = this.configurationObject.bookmakers;
			} else if (this.configurationObject.bookmakerThemeSportExceptions
				&& this.configurationObject.bookmakerThemeSportExceptions.includes(sportCode)) {
				bookmakerList = ["tab"];
			} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}
			this.sportDataService.getPreMatchData(matchid, true, bookmakerList)
				.then((match) => {
					this.match = match;
					
					this.prepareMatchData();
				})
				.catch((err) => {
					if (err !== "API_CALL_FAILED") {
						// this._Rollbar.error(err);
						console.error(err);
					}
					this.gamesError = true;
				});
		}

		
	}

	reloadSingleGame = (matchID: string): void => {
		// call to retrieveSingleGame has to be within Promise due to $scope.$apply calls within, which cause issues if called on the main thread
		Promise.resolve(true).then(() => {
			this.retrieveSingleGame(matchID);
		});
	}
}
